const BASE_SPACING = 12;

/** @todo look at tailwind's implementations; this needs improving */
const spacing = {
  baseSpacing: "".concat(BASE_SPACING, "px"),
  quarterSpacing: "".concat(BASE_SPACING / 4, "px"),
  halfSpacing: "".concat(BASE_SPACING / 2, "px"),
  threeQuarterSpacing: "".concat(BASE_SPACING * 1.5, "px"),
  doubleSpacing: "".concat(BASE_SPACING * 2, "px")
};
const stripUnit = unit => breakpoints.map(bp => bp.replace(unit, ''));
const breakpoints = ['576px', '768px', '992px', '1200px'];
const unitlessBreakpoints = stripUnit('px');
const mediaQueries = {
  sm: "@media screen and (min-width: ".concat(unitlessBreakpoints[0], "px)"),
  md: "@media screen and (min-width: ".concat(unitlessBreakpoints[1], "px)"),
  lg: "@media screen and (min-width: ".concat(unitlessBreakpoints[2], "px)"),
  xl: "@media screen and (min-width: ".concat(unitlessBreakpoints[3], "px)"),
  smMax: "@media screen and (max-width: ".concat(unitlessBreakpoints[0] - 1, "px)"),
  mdMax: "@media screen and (max-width: ".concat(unitlessBreakpoints[1] - 1, "px)"),
  lgMax: "@media screen and (max-width: ".concat(unitlessBreakpoints[2] - 1, "px)"),
  xlMax: "@media screen and (max-width: ".concat(unitlessBreakpoints[3] - 1, "px)")
};
const page = {
  maxWidth: '1170px'
};
const layout = {
  breakpoints,
  mediaQueries,
  page,
  spacing,
  BASE_SPACING
};

export { BASE_SPACING, layout };
